// Map raw Supabase auth errors to friendlier user-facing copy.
//
// Used by both CustomerAuth and TradieAuth so the two flows speak the same
// language on the common failure cases. Falls through to the raw message for
// anything we haven't seen, so we never silently swallow a real problem.
//
// Coverage:
//   - Duplicate email on signup
//   - Rate limit (signup or signin)
//   - Invalid email format
//   - Password too short
//   - Invalid login credentials
//   - Unconfirmed email at signin
//   - Network / fetch failures (offline, DNS, timeout)
export function friendlyAuthError(message) {
  if (!message) return "Authentication failed.";
  const m = String(message).toLowerCase();

  if (m.includes("already registered") || m.includes("already exists")) {
    return "An account with this email already exists. Try signing in, or use the 'Forgot password' link.";
  }
  if (m.includes("rate limit") || m.includes("too many")) {
    return "Too many attempts. Please wait a few minutes and try again.";
  }
  if (m.includes("invalid login credentials") || m.includes("invalid credentials")) {
    return "That email and password don't match. Try again, or use 'Forgot password' to reset.";
  }
  if (m.includes("email not confirmed") || m.includes("confirm your email")) {
    return "Please confirm your email first — check your inbox for the confirmation link.";
  }
  if (m.includes("invalid email")) {
    return "That email address doesn't look right. Please double-check it.";
  }
  if (m.includes("password") && (m.includes("short") || m.includes("at least"))) {
    return "Password is too short — please use at least 6 characters.";
  }
  if (m.includes("network") || m.includes("fetch") || m.includes("failed to fetch")) {
    return "We couldn't reach the server. Check your connection and try again.";
  }

  return message;
}
